export const HAS_AI_FAQS_ENABLED = false
export const HAS_MAIN_IMAGE_ENABLED = false
export const HAS_ALERTS_ON_LEAD_ENABLED = false
export const HAS_APP_SUGGESTION_DRAWER_ENABLED = false
export const HAS_AD_DETAIL_TRUST_CERTIFICATION_ENABLED = false
export const HAS_AD_DETAIL_TRUST_CARFAX_ENABLED = false
export const HAS_AD_DETAIL_TECHNICAL_DATASHEET_ENABLED = false
export const HAS_AD_DETAIL_EXTRAS_PRICE_ENABLED = false
export const HAS_CSAT_NPS_ENABLED = false
export const HAS_CSAT_BUYER_ENABLED = false
